export const MEDIA_QUERY_769 = 769;
export const COLOR_VIOLET = '#7D61A7';
export const COLOR_LIGHT_DARK = '#181818';

export const CHAT_TIME_LIMIT_SECONDS = 60;

export const CHAT_MAX_MESSAGES_UNREGISTER = 5;

export const DEFAULT_REQUEST_TIMEOUT = 10000;

export const UNAUTHORIZED_RESPONSE_CODE_REFRESH = 401;

export const UNAUTHORIZED_RESPONSE_CODE_REJECT = 403;

export const REQUEST_FAILED = 404;

export const BAD_REQUEST = 400;

export const SERVER_ERROR = 500;

export const ASTROLOGY_BASE_URL = 'https://www.astrology.com';

export const ASTROLOGY_BASE_URL_PRIVACY = `${ASTROLOGY_BASE_URL}/privacy.html`;
export const REVIEW_FORM_LINK = 'https://docs.google.com/forms/d/e/1FAIpQLScSDLwLrF1BmZ45X1DsdBwtZrdg4TuSiVcZSl8qUy8WA-rakw/viewform';
export const SHARE_LANDING_LINK = 'https://veda.astrology.com/?utm_source=sharing&utm_medium=chat';
export const APP_URL_CHAT_HISTORY = 'chat-history';
export const APP_URL_CHAT = 'advisor';
export const APP_URL_REDIRECT_CHAT = 'chat';
export const APP_URL_CHAT_VEDA = 'advisor';
export const APP_URL_CHAT_VEDA_SHARE = 'share-chat';
export const APP_URL_CHAT_SHARE = 'share-chat';
export const APP_URL_NOT_FOUND = 'not-found';
export const APP_URL_USER_DELETION_STATUS = 'user-deletion-status';
export const APP_URL_HOME = '/';
export const APP_URL_PROFILE = 'profile';
export const APP_URL_LANDING = 'landing';
export const APP_URL_CATALOG = 'catalog';
export const APP_URL_WIDGET = 'widget';
export const APP_URL_WIDGET_CHAT = 'widget-chat';
export const APP_URL_SUBSCRIPTION = 'subscription';
export const APP_URL_PAYMENT = 'payment';
export const APP_URL_PAYMENT_HISTORY = 'payments-history';
export const APP_URL_PAYMENT_RESULT = 'payment-result';
export const APP_URL_ACTIVITIES = 'activities';
export const APP_URL_ACTIVITY = 'activity';

export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const BASE_APP_URL = process.env.REACT_APP_BASE_URL;
export const GOOGLE_AUTH_URL = `${BASE_URL}/auth/google`;
export const FACEBOOK_AUTH_URL = `${BASE_URL}/auth/facebook`;
export const CHECKOUT_PUBLIC_KEY = process.env.REACT_APP_CHECKOUT_PUBLIC_KEY;
export const GOOGLE_PAY_MERCHANT_ID = process.env.REACT_APP_GOOGLE_PAY_MERCHANT_ID;
export const APPLE_PAY_MERCHANT_ID = process.env.REACT_APP_APPLE_PAY_MERCHANT_ID;
export const APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const APP_GIT_BRANCH = process.env.REACT_APP_GIT_BRANCH;
export const APP_GIT_COMMIT = process.env.REACT_APP_GIT_COMMIT;

export const DEFAULT_CALENDAR_START_DATE = '1990/01/10';

export const STORAGE_KEY_ACCESS_TOKEN = 'accessToken';
export const STORAGE_KEY_CHATS_MESSAGES_COUNT = 'chatsMessagesCount';
export const STORAGE_KEY_SAVED_USER_MESSAGES = 'chatsSavedMessages';
export const STORAGE_KEY_ACTIVE_CHAT = 'activeChatId';
export const UNREG_CHATS_ID = 'vedaUnregisterChatsId';
export const STORAGE_KEY_SELF_CREATED_CHAT = 'selfCreated';
export const STORAGE_KEY_USER_START_LOGIN = 'vedaUserStartLogin';
export const STORAGE_KEY_RESEND_MESSAGES = 'resendMessages';
export const STORAGE_KEY_FORCE_LOGOUT = 'wasForcedLogout';
export const STORAGE_KEY_URL_BEFORE_PAYMENT = 'urlBeforePayment';
export const STORAGE_KEY_DATA_FOR_RETRY_PAYMENT = 'dataForRetryPayment';
export const STORAGE_KEY_NO_TYPEWRITER_ANIMATION = 'noTypeWriterAnimation';
export const STORAGE_KEY_USER_VISITED_PAYMENTS = 'isUserVisitedPayments';

export const STORE_AUTH_PAYMENT_POPUP = {
    trial: 'trial',
    product: 'product',
    plan: 'plan',
    issue: 'issue'
};

export const STORE_PAYMENT_MODAL_TYPE = {
    trial: 'trial',
    subscription: 'supscription'
};

export const DEFAULT_CHAT_NAME = 'New chat';

export const CATEGORY_QUERY_NAME = 'category';
export const USER_CHAT_ROLE = {
    USER: 'user',
    SYSTEM: 'system',
    ASSISTANT: 'assistant',
    USER_CHAT_CONNECTED: 'user_chat_connected',
    USER_CHAT_DISCONNECTED: 'user_chat_disconnected'
};

export const PURCHASES_BANNER_TYPE = {
    0: 'Get More Guidance',
    1: 'Empathy Meets AI'
};

export const OG_URL = 'https://veda.astrology.com/?utm_source=sharing&utm_medium=chat';

export const STATIC_PAGES_LINKS = {
    ABOUT: 'https://www.astrology.com/us/aboutus.aspx',
    CONTACT: 'https://www.astrology.com/us/feedback.aspx',
    ADVERTISING: 'https://www.astrology.com/us/advertising-inquiry.aspx',
    PRIVACY: 'https://www.astrology.com/privacy.html',
    TERMS: 'https://www.astrology.com/tos.html'
};

export const SOCIAL_PAGES_LINKS = {
    FACEBOOK: 'https://www.facebook.com/Astrologycom',
    INSTAGRAM: 'https://www.instagram.com/astrologydotcom/',
    YOUTUBE: 'https://www.youtube.com/channel/UCVIPl_wcAVfel6aW99ZELKg/',
    TWITTER: 'https://twitter.com/astrology_com'
};

export const WSS_AUTO_RECONNECT_INTERVAL = 5000;
export const APP_WS_URL = process.env.REACT_APP_WS_URL;
export const CHAT_TYPE = {
    SINGLE: 'single',
    MULTIPLY: 'multiply'
};
export const EXTERNAL_CHECKOUT_PROD_JS_LIBRARY_PATH = 'https://risk.checkout.com/cdn/risk/1/risk.js';
export const EXTERNAL_CHECKOUT_DEV_LIBRARY_PATH = 'https://risk.sandbox.checkout.com/cdn/risk/1/risk.js';
export const SEND_MESSAGE_ID = 'send_message_id';
export const ACCEPTED_FILE_LOADER = {
    IMAGE: ['image/png', 'image/jpeg', 'image/jpg']
};

export const DEFAULT_IMAGE_SIZE_LIMIT = 5 * 1024 * 1024;
